module['exports'] = [
  'چیونٹیاں',
  'چمگادڑ',
  'بھالو',
  'مکیاں',
  'پرندے',
  'بیل',
  'بلیاں',
  'مرغیاں',
  'مویشی',
  'کتے',
  'مچھلیاں',
  'بطخیں',
  'ہاتھی',
  'لومڑیاں',
  'مینڈک',
  'بکریاں',
  'گھوڑے',
  'شیر',
  'بندر',
  'الو',
  'لوگ',
  'سور',
  'خرگوش',
  'بھیڑ',
  'بھیڑیں',
  'زیبرا',
  'کویں',
  'کالی بلیاں',
  'بھوت',
  'جادوگر',
  'بیٹیں',
  'دشمن',
  'پیغمبر',
  'روح',
  'عبادت گزار',
];
